import { LOGIN_RESPONSE_ERROR } from 'common/constants/login';
import { CARD_NAME } from 'common/constants/card';
import { MOBILITY_NAME } from 'common/constants/mobility';

const translates = {
  yes: 'Yes',
  no: 'No',
  ok: 'Ok',
  apply: 'Apply',
  save: 'Save',
  cancel: 'Close',
  cancelChanges: 'Cancel',
  nothingFound: 'Nothing found',
  company: 'Company',
  details: 'Details',
  name: 'Name',
  email: 'E-mail',
  phoneNumber: 'Phone',
  volume: 'Volume',
  download: 'Download',
  print: 'Print',
  downloadFile: 'Download file',
  station: 'Station',
  brand: 'Brand',
  gpsLongitude: 'Longitude',
  gpsLatitude: 'Latitude',
  gpsLongitudeAndLatitude: 'Latitude, longitude',
  stationCategory: 'Station category',
  suitableForTrucks: 'Available for trucks',
  address: 'Address',
  route: 'Route',
  prices: 'Prices',
  reset: 'Reset',
  whereFrom: 'From where',
  where: 'Where',
  noData: 'No data',
  filter: 'Filter',
  legend: 'Legend',
  exit: 'Exit',
  login: 'Login',
  password: 'Password',
  'password.visibility': 'Show password',
  'password.visibilityOff': 'Hide password',
  requestAccess: 'Request Access',
  enter: 'Login',
  nip: 'Tax id. no. (NIP)',
  shares: 'Special offers',
  showResult: 'Show result',
  additionalParameters: 'Additional parameters',
  typeOfRoadsideService: 'Type of roadside service',
  offerAgreement: 'Contract offer',
  paymentInvoice: 'Invoice',
  aboutE100Card: 'About E100 card',
  orderCard: 'Order a card',
  stationActive: 'Standard',
  stationDiscont: 'Discount',
  stationPM: 'Optimum',
  stationEconom: 'Value',
  store: 'Roadside service',
  favoriteStation: 'Favorite station',
  stationSale: 'Promotional refuel station',
  cluster: 'Several gas stations at',
  stationInfo: 'Service point information',
  stationAddress: 'Station address',
  stationNotes: 'Station notes',
  priceUpdated: 'Price is updated',
  country: 'Country',
  relevantOn: 'Current on',
  additionalServices: 'Additional services',
  'additionalServices.subtitle': 'Without the use of a fuel card',
  stationSpecialEvents: 'Special events',
  stationSpecialEventsPeriod: 'Event duration',
  emptySpecialEvents: 'No special events at the moment',
  'buildingRoute.buildRoute': 'Build a route',
  'buildingRoute.routeDetails': 'Route details',
  'login.toTheE100Website': 'Back to site',
  'east.login.toTheE100Website': 'Back to site',
  'login.logInToPersonalAccount': 'Log in',
  'login.openOldVersion': 'Switch back to old version',
  'login.goBackToPersonalAccount': 'Client Login',
  'login.goBackToPersonalAccountRR': 'Go to Account',
  'login.orderCard': 'Order a card',
  'login.account': 'Account',
  'login.unauthorizedUser': 'Unauthorized user',
  'print.listOfRouteServicePoints': 'List of services on the route',
  'print.listOfRouteServicePointsWithPrices':
    'List of services on the route with prices',
  'buildingRoute.stationsFoundOnRoute': 'Found stations on route',
  'buildingRoute.intermediatePoint': 'Intermediate point',
  'buildingRoute.addPoint': 'Add point',
  'buildingRoute.addPoint.infoMessage':
    'You can add a maximum of 8 intermediate points',
  'buildingRoute.error.noSuchCityOrCountry': 'There is no such city or country',
  'buildingRoute.error.impossibleToBuildRoute': 'Impossible to plot a route',
  'buildingRoute.error.noStartAndEndPointsSelected':
    'It is impossible to plot a route. Start and end points are not selected.',
  'buildingRoute.error.noStartingPointSelected':
    'It is impossible to plot a route. Start point are not selected.',
  'buildingRoute.error.noEndpointSelected':
    'It is impossible to plot a route. End point are not selected.',
  'filter.additionalParameters': 'Additional options',
  'filter.gasStationBrand': 'Gas station brand',
  'filter.findGasStationBrand': 'Find gas station brand',
  'filter.findCountry': 'Find a country',
  'filter.selectCountry': 'Choose a country',
  'filter.findRegion': 'Find Region',
  'filter.region': 'Region',
  'filter.servicesAtStation': 'Station services',
  'filter.serviceFormat': 'Service format',
  'filter.stationCategory': 'Station category',
  'filter.findTrack': 'Find Track',
  'filter.track': 'Track',
  'filter.gasStationFilter': 'Filter of the stations',
  'filter.listSP': 'List of stations',
  'filter.displayListOfSP': 'Display stations list',
  'filter.displayListOfSPWithPrices': 'Display stations list with prices',
  'filter.listSPWithPrices': 'List of stations with prices',
  'filter.stationFilter': 'Filter of the stations',
  'filter.filterResetModal.title': 'Reset filter',
  'filter.filterResetModal.text':
    'Are you sure you want to reset the settings?',
  'filter.authorizationLink1': 'To view prices, please',
  'filter.authorizationLink2': 'log in',
  'filter.favoriteStations': 'Favorite stations',
  'filter.hasEvents': 'Special offers',
  'stationInfo.priceUpdated': 'Price updated',
  'languages.ru': 'Русский',
  'languages.lt': 'Lietuvių',
  'languages.en': 'English',
  'languages.tr': 'Türkçe',
  'languages.pl': 'Polski',
  'languages.uk': 'Український',
  'languages.es': 'Español',
  'orderCardsModal.unitMeasureFuelValume': 'l./month',
  'orderCardsModal.possibleLending': 'Crediting is possible',
  'orderCardsModal.privacyPoliceDescription': 'I agree to e-mail contact',
  'orderCardsModal.representativeOfLegalEntity':
    'I agree to be contacted via phone',
  'orderCardsModal.privacyPoliceModal.title':
    'Consent to be contacted by Email',
  'orderCardsModal.privacyPoliceModal.text':
    'I consent to the processing by E100 International Trade Sp. z o.o. my personal data in the form of an e-mail address for the purpose of sending me marketing information regarding products and services offered by E100 International Trade Sp. z o.o. by means of electronic communication, pursuant to the provisions of art. 10 sec. 1 and 2 of the Act on the provision of electronic services. Detailed rules regarding the processing of personal data and marketing consents are set out in the information clause. Before giving marketing consent, please read its content.',
  'orderCardsModal.representativeOfLegalEntityModal.title':
    'Consent to be contacted by phone',
  'orderCardsModal.representativeOfLegalEntityModal.text':
    'I consent to the processing of my personal data in the form of the telephone number provided by me by E100 International Trade Sp. z o.o. in order to conduct marketing activities with the use of telecommunications terminal equipment and automatic calling systems within the meaning of the Telecommunications Law. Detailed rules regarding the processing of personal data and marketing consents are set out in the information clause. Before giving marketing consent, please read its content.',
  'orderCardsModal.orderCard': 'Order a card',
  'orderCardsModal.sendRequest': 'Send a request',
  'orderCardsModal.description':
    'Would you like to test E100 fuel card for free? Fill out the form and we will contact you to clarify the terms of delivery.',
  'orderCardsModal.title': 'Order a card for free',
  'orderCardsModal.cardCount': 'Number of cards',
  'orderCardsModal.prePay': 'Prepayment amount',
  'orderCardsModal.prePay.recommendedAmount':
    'The recommended prepayment amount is 1000 rubles.',
  'orderCardsModal.totalAmount': 'Total amount',
  'orderCardsModal.finishRegistration': 'Finish registration',
  'orderCardsModal.formSentSuccess': 'The order has been sent',
  'orderCardsModal.ru.secondStep.title':
    'Ordering fuel cards and issuing a payment document',
  'orderCardsModal.ru.thirdStep.title1': 'Your order has been accepted,',
  'orderCardsModal.ru.thirdStep.title2': 'our manager will contact you soon.',
  'orderCardsModal.ru.thirdStep.subtitle': 'Thank you for choosing E100!',
  'orderCardsModal.ru.thirdStep.numberOfCards': 'Number of E100 cards',
  'orderCardsModal.ru.thirdStep.prePay': 'Prepayment amount',
  'orderCardsModal.ru.thirdStep.description1':
    'Below you can find a commercial proposal,',
  'orderCardsModal.ru.thirdStep.description2':
    'a contract offer, and an invoice for payment.',
  'orderCardsModal.ru.thirdStep.conditionTitle': 'draw your attention to',
  'orderCardsModal.ru.thirdStep.conditionText1':
    'Payment of the invoice is acceptance of the terms of the contract offer.',
  'orderCardsModal.ru.thirdStep.conditionText2':
    "In each invoice in the column 'purpose of payment,' it is necessary to indicate the number of your contract offer. Your contract offer number.",
  'stationSearch.title': 'Search (gas station code, coordinates, address)',
  'stationInfo.availableAtGasStations': 'Available at petrol stations',
  'stationInfo.aboutStation': 'About station',
  'stationInfo.refillsByCard': 'Refueling by fuel card',
  'stationInfo.serviceDescriptionForSpain':
    '* The price includes a discount from the Spanish government of 0.20 € (valid until 12/31/2022).',
  'error.fieldCannotBeEmpty': 'The field cannot be empty',
  'error.onlyLatinLettersAndNumbers': 'Only Latin numbers and letters',
  'error.allowedNumberCharacters': 'The allowed number of characters',
  'erorr.emailNotValid': 'Е-mail is not valid',
  'error.invalidCharacter': 'Invalid character',
  'error.phoneNotValid': 'The phone number is not valid',
  'error.partialDataUnavailable':
    'Some data is temporarily unavailable. Please try refreshing the page.',
  [`error.${LOGIN_RESPONSE_ERROR.userOrPasswordInvalid}`]: 'Invalid data',
  [`error.${LOGIN_RESPONSE_ERROR.accessError}`]:
    'Please contact your E100 regional manager',
  [`error.${LOGIN_RESPONSE_ERROR.passwordNeedsToBeReplaced}`]:
    'Your password must be changed',
  [`error.${LOGIN_RESPONSE_ERROR.loginTemporarilyBlocked}`]:
    'The ability to enter was blocked for 15 minutes.',
  [`error.${LOGIN_RESPONSE_ERROR.loginFromWrongTerritory}`]:
    'Incorrect login credentials entered. Please call the hotline',
  km: 'km.',
  loading: 'Loading...',
  'filter.closeWindow.text':
    'Are you sure you want to close the window (the parameters will be reset)',
  hours: 'h.',
  min: 'min.',
  '24/7': '24 hours a day',
  withoutTechnicalBreaks: 'Without taking into account technical breaks',
  workingHours: 'Working hours',
  monday: 'MO',
  tuesday: 'TU',
  wednesday: 'WE',
  thursday: 'TH',
  friday: 'FR',
  saturday: 'SA',
  sunday: 'SU',
  weekend: 'Closed',
  noWorkHours: 'There are no data on working hours',
  refuelingMode: 'Refueling mode',
  avoid: 'Avoid',
  highways: 'Highways',
  tolls: 'Tolls',
  plots: 'Plots',
  tollsConnect: 'Connect tolls',
  ferries: 'Ferries',
  'netto.serviceDescription': `The Net price on the ${CARD_NAME} invoice may differ depending on the local time of the station, as well as due to rounding, currency conversions, devaluation processes, and the time of arrival at the refuel stations.`,
  includeNettoPrices: 'Include Net price',
  'confirmSubmitFilterFormModal.title': 'Attention',
  'confirmSubmitFilterFormModal.text1':
    'The stations shown may have gas stations that only support refueling through a mobile application.',
  'confirmSubmitFilterFormModal.text2':
    'Pay attention to the "Refueling mode" filter.',
  'confirmSubmitFilterFormModal.link': `Learn more about ${MOBILITY_NAME('en')}`,
  brutto: 'Gross price',
  netto: 'Net price',
  availableServicesAtStation: 'Available services at the station',
  copy: 'Copy',
  replicate: 'Copy',
  copied: 'Copied',
  'authModal.title': 'Log in',
  'authModal.info':
    'Dear Customer! In order to protect your account from fraudsters, the ability to enter will be blocked for 15 minutes in case you enter an incorrect login or password more than 10 times',
  'authModal.infoAboutSpecialEventsForAuthorizedOnly':
    'Please log in to see the available list of gas stations with the event',
  map: 'Map',
  satellite: 'Satellite',
  'feedbackModal.addReview': 'Leave a review',
  'feedbackModal.attachFile': 'Attach a file',
  'feedbackModal.fileMaxSize':
    'Files in the following formats can be attached PNG, JPG, PDF, MOV, MPEG. Total volume of files should not exceed 25 MB.',
  'feedbackModal.review': 'Your review',
  'feedbackModal.fileMaxSizeErr':
    'The file was not added. Total size of the files exceeds {size} MB',
  'feedbackModal.contactPhone': 'Contact phone number',
  'feedbackModal.contactEmail': 'Contact email address',
  'feedbackModal.reviewInfoMsg': 'Leave feedback about the Client Portal',
  'feedbackModal.reviewInfoMsg2':
    'Write your review about the work of your personal account to improve our service.',
  'feedbackModal.send': 'Send',
  'feedbackModal.cancel': 'Cancel',
  'feedbackModal.name': 'Name',
  'feedbackModal.phoneOrEmail': 'Contact email or phone number',
  'feedbackModal.fieldCannotBeEmpty': 'Field can not be empty',
  'feedbackModal.invalidPhoneNumber': 'Invalid phone number',
  'feedbackModal.invalidEmail': 'Invalid email address',
  'feedbackModal.success': 'Thank you. Your review was sent',
  'feedbackModal.error': 'Something went wrong. Please try again later.',
  somethingGoWrong: 'Something went wrong',
  'e100OnlineMessage.title': 'Only online refuelling is possible',
  'e100OnlineMessage.description': `Only refueling via the ${CARD_NAME} mobile app is available. Plastic fuel cards are not accepted. Learn more about online refueling:`,
  locatorSettings: 'Locator settings',
  netPriceDisplay: 'Display of NET prices',
  autoScaling: 'Autoscaling',
  servicePointDisplayRadius:
    'Radius for displaying service stations on the route',
  'servicePointDisplayRadius.label': 'Radius in km',
  'differentPrice.title':
    'The sign "~" indicates that the cost may vary depending on the selected product or service.',
  showCars: 'Show vehicles',
  hideCars: 'Hide vehicles',
  secureEBox: 'Secure E-BOX',
  'clientCars.modal.text1':
    'Do you want to see the location of your vehicles in the E100 locator?',
  'clientCars.modal.text2': 'Login and activate the Secure E-BOX service.',
  'clientCars.modal.text3': 'Activate the Secure E-BOX service.',
  auto: 'Vehicle',
  card: 'Card',
  OBU: 'OBU',
  coordinates: 'Coordinates',
  updateTime: 'Update time',
  moreDetailed: 'More details',
  reports: 'Reports',
  preparationForExport: 'Export preparation',
  readyToDownload: 'Ready to download',
  hasStationLimitBeenExceeded: 'The number of stations should not exceed 1000',
  reportErrorTooltip: 'An error occurred, please try again',
  hideStations: 'Hide Stations',
  showStations: 'Show Stations',
  comment: 'Comment',
  share: 'Share',
  'sharedStationLinkModal.text1': 'Write a comment for the driver (optional).',
  'sharedStationLinkModal.text2':
    'Send the copied text to the driver in any convenient way (for example, through messaging apps).',
  'shareStationLinkMessage.text1': 'Share information about the gas station',
  'shareStationLinkMessage.text2': 'is here',
  'shareStationLinkMessage.text3':
    "If you don't have the app installed, be sure to download",
  'shareStationLinkMessage.text4': 'Continue after installation',
  messageCopied: 'Text copied',
  copyMessage: 'Copy text',
  cardsLinkedToOBU: 'Cards linked to OBU',
  showLinkedCards: 'Show added cards',
  'favoriteStations.add': 'Add to Favorites',
  'favoriteStations.remove': 'Remove from favorites',
  'favoriteStations.addError': 'Failed to add to favorites',
  'favoriteStations.removeError': 'Failed to remove from favorites',
  'favoriteStations.addSuccess': 'Added to favorites',
  'favoriteStations.removeSuccess': 'Removed from favorites',
  network: 'Network of stations',
  view: 'View',
  resetEventFilter: 'Reset event filter',
  'report.unauthorized.delete': 'Delete report',
  'report.unauthorized.ready': 'Report is ready',
  'report.unauthorized.initiated': 'Report creation initiated',
  'report.unauthorized.creating': 'Report is being prepared',
  'responseStatus.429':
    'Request limit exceeded. Please wait a moment and try again.',
  'favoriteCatalogs.title': 'Favorites',
  'favoriteCatalogs.limitExceeded':
    'Maximum number of directories reached: {maxLimit}',
  'favoriteCatalogs.nameLengthExceeded': 'Maximum characters: {maxLength}',
  'favoriteCatalogs.limitInCatalogExceeded':
    'Maximum number of stations for the directory has been reached: {maxLimit}',
  'favoriteCatalogs.limitStationsInCatalogExceeded':
    'The maximum number of stations in the catalog has been reached: {maxLimit}',
  'favoriteCatalogs.limitStationsInCatalogExceededAmount':
    'The total number of stations in the catalog cannot exceed {maxLimit}. {currentAmount}/{maxLimit} has been added. Please check the list of stations to be added and remove unnecessary ones.',
  'favoriteCatalogs.deleteTitle':
    'Remove station {stationCode} from {catalogName}?',
  'favoriteCatalogs.empty': 'No catalogs created',
  'favoriteCatalogs.addToCatalog': 'Add to catalog',
  'favoriteCatalogs.createCatalog': 'Create catalog',
  'favoriteCatalogs.deleteCatalog': 'Delete directory {catalogName}?',
  'favoriteCatalogs.emptyCatalog': 'No stations added',
  'fuelCards.selectCard': 'Select card',
  'fuelCards.noAvailableCards': 'No available cards',
  'fuelCards.title': 'Fuel Cards',
  'fuelCards.placeholder': 'Search Card / Driver Name / Vehicle Number',
  'fuelCards.notFound': 'Not Found',
  'fuelCards.fuelLimitsNotAvailable':
    'Fueling with the selected card is prohibited at this gas station',
  'fuelCards.availableLimit': 'Available balance',
  'fuelCards.why': 'Why select a card?',
  'fuelCards.whyModalTitle1': 'Available Fuel Calculation',
  'fuelCards.whyModalText1': `After selecting a card, the gas station shows available fuel amount calculated based on your company's balance and set limits.`,
  'fuelCards.whyModalTitle2': 'Important to Know',
  'fuelCards.whyModalText2':
    'If refueling at a gas station is prohibited, such station will be displayed in gray on the map.',
  'fuelCards.fuelLimitsTip':
    'Available fuel is calculated based on company balance and set limits',
  'favoriteCatalogs.newCatalog': 'New catalog',
  'favoriteCatalogs.importCatalog': 'Import',
  'favoriteCatalogs.newCatalogName': 'Catalog name',
  'favoriteCatalogs.typeNewCatalogName': 'Enter a catalog name',
  'favoriteCatalogs.addStations': 'Add stations',
  'favoriteCatalogs.addStation': 'Add station',
  'stationsForm.placeholder': 'Enter station codes',
  'stationsForm.addCodes': 'Add station codes',
  'stationsForm.title': 'Stations',
  'stationsForm.deleteCodes': 'Delete selected stations',
  'stationsForm.findPlaceholder': 'Find a station',
  'favoriteCatalogs.create': 'Create',
  'favoriteCatalogs.import': 'Import',
  'importCatalogForm.title': 'Import Catalog',
  'importCatalogForm.helperText': 'Paste the previously copied catalog here',
  'favoriteCatalogs.addStationsToCatalog': 'Add stations to "{catalogName}"',
  'favoriteCatalogs.stationsNotFound':
    'The following stations were not found in the system: {stationCodes}',
  'favoriteCatalogs.rejectedCodes':
    'The following stations were not added: {stationCodes}',
  'favoriteCatalogs.stationsAlreadyInCatalog':
    'The following stations are already in the catalog: {stationCodes}',
  'favoriteCatalogs.nameExists': 'The catalog {catalogName} already exists.',
  'favoriteCatalogs.changeName': 'Rename Catalog',
  'favoriteCatalogs.incorrectJSON':
    'Error importing station catalog. Data format does not meet requirements. Please check that the data being transferred is correct.',
  'favoriteCatalogs.duplicatedCodes':
    'Warning! Duplicate station codes were found in the catalog. Duplicates were automatically removed from the list of added gas stations.',
  gotIt: 'Got it',
  selectFuelType: 'Select fuel type',
  selectFileTypeForComparing: 'Compare prices',
  selectFuelTypeFirst: 'Select fuel type first',
  change: 'Edit',
  create: 'Create',
  comparePricesConfirmTitle:
    'You are about to create a file <b>{fileName}</b> with a price comparison of <b>{serviceName}</b>',
  comparePriceTitle: ' Price Comparison at Gas Stations',
  stationCodeCopied: 'Station code copied',
  'fuelAvailability.title': 'Fuel Type',
  'fuelAvailability.placeholder': 'Fuel station availability',
  'fuelAvailability.DIESEL': 'Diesel',
  'fuelAvailability.AI92': 'AI-92',
  'fuelAvailability.AI95': 'AI-95',
  'fuelAvailability.AI98_100': 'AI-98/100',
  'fuelAvailability.ALL': 'All stations',
  'fuelAvailability.Restrictions': 'With restrictions',
  'fuelAvailability.RestrictionsTooltip': 'Fueling with the selected card is limited',
  'fuelAvailability.Available': 'Without restrictions', 
  'fuelAvailability.AvailableTooltip': 'Fueling with the selected card is not limited', 
  'fuelAvailability.ALL_STATIONS': 'All stations', 
  'fuelAvailability.show': 'Show',
  'restrictionStatus.available': 'Transactions available',
  'restrictionStatus.unavailable': 'No transactions',
  'restrictionStatus.probably_unavailable': 'Few transactions',
  'restrictionStatus.unknown': 'No transactions',
  'restrictions.title': 'Restrictions',
  'restrictions.paymentType.card': 'Card',
  'restrictions.paymentType.mobile': 'Mobile',
  'restrictions.upTo':'up to',
  'restrictions.more': 'More about gas station availability',
  'restrictions.moreTip0': 'Gas station availability is determined based on the analysis of transactions with fuel cards and through the mobile application.<ul><li>High availability — transactions occur normally.</li><li>Possibly unavailable — transactions occur irregularly.</li></ul>',
  'restrictions.moreTip1': 'Information about gas station availability and current restrictions is for reference only, based on internal analytics and/or aggregated data, and is not obtained directly from gas stations. The company does not guarantee its completeness, accuracy, or real-time relevance and is not responsible for any losses resulting from the use of such information. It is recommended to check the actual possibility and conditions of fueling on-site or with the gas station operator.',
  'restrictions.moreTip2': 'Refueling conditions are divided into three types: <ul><li>All — all stations, regardless of the conditions for fueling with E1 CARD fuel cards.</li><li>With restrictions — a regulated fuel allowance is set for E1 CARD fuel cards.</li><li>Without restrictions — no regulated fuel allowance is set for E1 CARD fuel cards.</li></ul>',
  'restrictions.tip1': 'Information about gas station availability and current restrictions is for reference only, based on internal analytics and/or aggregated data, and is not obtained directly from gas stations. The company does not guarantee its completeness, accuracy, or real-time relevance and is not responsible for any losses resulting from the use of such information. It is recommended to check the actual possibility and conditions of fueling on-site or with the gas station operator.',
  'restrictions.tip2': 'Available services at the service station are determined based on the analysis of transactions with fuel cards and through the mobile application. <ul><li>Transactions available — transactions occur normally.</li><li>Few transactions — transactions occur irregularly.</li><li>No transactions — transactions are currently absent.</li></ul>',
  'restrictions.conditions': 'Refueling conditions',
  'filter.saved': 'Saved filter',
  'filter.savedHelper': 'Select a saved filter, or set up a filter below and save it',
  'filter.noAvailableFilters': 'No saved filters',
  'filter.selectSavedFilter': 'Select a saved filter',
  'filter.savedFilters': 'Saved filters',
  'filter.searchByName': 'Search by name',
  'filter.saveFilter': 'Save filter',
  'filter.saveAfterChanges': 'Saving will be available after changing the filter',
  'deleteFilterModal.confirmation':
  'Are you sure you want to delete the "{name}" filter? This action cannot be undone.',
  'deleteFilterModal.helperText': 'After deletion, the filter will disappear from the list of saved filters.',
  'delete': 'Delete',
  'deleteFilterModal.title': 'Delete filter',
  'saveFilterModal.title': 'Save filter',
   'saveFilterModal.subtitle': 'Enter a name for the filter',
   'saveFilterModal.helperText':'After saving, the filter will appear in the "Saved filter" list',
   'saveFilterModal.placeholder': 'For example: "Only gas stations in Moscow"',
   'updateFilterModal.title': 'Update filter',
   'update': 'Update',
   'filter.saveFilter.nameExists': 'A filter with this name already exists.',
  'fuelAvailability.availability': 'Fuel station availability',
  'fuelAvailability.availability.available': 'High availability',
  'fuelAvailability.availability.probably_unavailable': 'Possibly unavailable',
  'deleteFilterModal.removed': 'Filter deleted',
  'saveFilterModal.saved': 'Filter saved',
  'renameFilterModal.title': 'Rename filter',
  'renameFilterModal.subtitle': 'Enter a new name',
};

export default translates;
